/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IHosports1ColumnBannerData } from './hosports-1-column-banner.data';
import { IHosports1ColumnBannerProps } from './hosports-1-column-banner.props.autogenerated';

export interface IHosports1ColumnBannerViewProps extends IHosports1ColumnBannerProps<IHosports1ColumnBannerData> {

}

/**
 *
 * Hosports1ColumnBanner component
 * @extends {React.PureComponent<IHosports1ColumnBannerProps<IHosports1ColumnBannerData>>}
 */
class Hosports1ColumnBanner extends React.PureComponent<IHosports1ColumnBannerProps<IHosports1ColumnBannerData>> {
    public render(): JSX.Element | null {

        return this.props.renderView(this.props);
    }
}

export default Hosports1ColumnBanner;
